module.exports = __webpack_public_path__ + "img/spiagge-logo-yellow-square-small.7f64a016.png";